// pages/Dashboard/Dashboard.js
import React, { useEffect } from "react";
import ChatbotScripts from './ChatbotScripts';
import UsedTokensChart from "./UsedTokenByDate";
import StatsBox from "./StatsBox";
import ChatbotStatsTable from "./StatsTable";
import { useChatbots } from "../../contexts/ChatbotContext";
import { Box, CircularProgress, Typography,  Paper, Divider } from '@mui/material';

export default function Dashboard() {
    const { activeChatbot, isLoading: isChatbotLoading } = useChatbots();
    useEffect(() => {
        document.title = 'Dashboard | KlonIT Web Application';
    }, []);

    if (isChatbotLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 200px)' }}>
                <CircularProgress />
                <Typography sx={{ ml: 2 }} color="text.primary">
                    Loading chatbots...
                </Typography>
            </Box>
        );
    }

    if (!activeChatbot) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 200px)' }}>
                <Typography color="text.primary">
                    No chatbot selected. Please create or select a chatbot.
                </Typography>
            </Box>
        );
    }

    return (
        <Paper sx={{ p: 3, mt: 10, mx: 'auto', maxWidth: '1200px', bgcolor: 'background.paper', height: '100%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h4" color="text.primary">
                    Dashboard for <strong>{activeChatbot.chatbot_name}</strong>
                </Typography>
            </Box>

            <Divider sx={{ mb: 3, borderColor: 'divider' }} />

            <Typography variant="body1" color="text.primary" sx={{ mb: 3 }}>
                View analytics, usage statistics, and activity details for your chatbot below.
            </Typography>

            {/* Stats summary boxes */}
            <StatsBox />

            <Box className="row mt-4" sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 4 }}>
                <Box className="col-lg-6" sx={{ flex: '1 1 48%' }}>
                    <ChatbotScripts />
                </Box>
                <Box className="col-lg-6" sx={{ flex: '1 1 48%' }}>
                    <ChatbotStatsTable />
                </Box>
            </Box>

            <Box sx={{ mt: 4 }}>
                <UsedTokensChart />
            </Box>
        </Paper>
    );
}
